export default __webpack_public_path__ + "static/media/template_business-man__0005_22---AndrewPant.c9b6f3e5.png";